import { useRef } from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import type { WarrantyInput } from '@econtractor/types';
import { FilesContainer, parseCloudFiles, stringifyCloudFiles } from 'modules/files';

interface TabFilesProps {
    id: number;
    files: string;
    canEdit: boolean;
    save: (values: WarrantyInput) => Promise<number | false>;
    saveFiles: (files: string, id?: number) => Promise<boolean>;
}

const TabFiles = ({ id, files, canEdit, save, saveFiles }: TabFilesProps) => {
    const { t } = useTranslation(['Warranties', 'common', 'FileNavigator']);
    const { values } = useFormikContext<WarrantyInput>();
    const savedId = useRef(id);
    if (id) savedId.current = id;
    return (
        <FilesContainer
            files={parseCloudFiles(files)}
            scope={{ warrantyId: id }}
            canEdit={canEdit}
            addButtonLabel={t('addFiles')}
            uploadingLabel={t('common:buttons.uploading')}
            saveFirstMessage={t('saveFirst')}
            errorMessage={t('errors.UNKNOWN')}
            uploadSuccessMessage={t('FileNavigator:messDownloadSuccess')}
            onFilesChange={(next) => saveFiles(stringifyCloudFiles(next), savedId.current)}
            onEnsureEntity={
                !id
                    ? async () => {
                          const created = await save(values);
                          if (!created) return false;
                          savedId.current = created;
                          return { warrantyId: created };
                      }
                    : undefined
            }
        />
    );
};

export default TabFiles;
